import { isEmail, isEmpty } from 'validator';

export default data => {
  let errors = {};

  if (!isEmail(data.email)) {
    errors.email = 'Please check your email address';
  }

  if (isEmpty(data.password)) {
    errors.password = 'This field is required';
  }

  return errors;
};
